<template>
  <div id="teaser">
    <section>
      <div class="section-head">
        <h2>
          {{ $t('common:highlights') }}
        </h2>
      </div>
      <div class="section-main">
        <div class="section-body">
          <div v-dompurify-html="descriptionsAexea.teaser" />
          <b-collapse
            id="teasers-hidden"
            class="mt-2"
          >
            <div
              v-show="false"
              ref="checkIcon"
            >
              <!-- fa check icon for replace in highlight text (have a lock at mounted) -->
              <i class="icon">
                <icon-check-alternative />
              </i>
            </div>
            <div
              ref="highlightText"
              v-dompurify-html="descriptionsAexea.description"
            />
          </b-collapse>
        </div>

        <div class="section-more">
          <a
            v-b-toggle.teasers-hidden
            class="btn btn-link btn-collapse show-object-teaser"
            data-ident="allHighlights"
            @click="replaceCheckIcon"
            @keydown="replaceCheckIcon"
          >
            <span class="more">
              <i class="icon">
                <icon-chevron-down />
              </i>
              {{ $t('common:allHighlights') }}
            </span>
          </a>
          <a
            v-smooth-scroll="{ duration: 200, updateHistory: false }"
            v-b-toggle.teasers-hidden
            href="#teaser"
            class="btn btn-link btn-collapse hide-object-teaser"
          >
            <span class="less">
              <i class="icon icon-only">
                <icon-chevron-up />
              </i>
              {{ $t('common:less') }}
            </span>
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { BCollapse, VBToggle } from 'bootstrap-vue';

/* ICONS */
import IconChevronUp from 'ICON:IconChevronUp';
import IconChevronDown from 'ICON:IconChevronDown';
import IconCheckAlternative from 'ICON:IconCheckAlternative';
import IconCheck from 'ICON:CheckCircle';

export default {
  name: 'ObjectAexea',
  components: {
    BCollapse,
    IconChevronUp,
    IconChevronDown,
    IconCheckAlternative,
    // eslint-disable-next-line vue/no-unused-components
    IconCheck,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  props: {
    descriptionsAexea: {
      type: Object,
      required: true,
    },
  },
  methods: {
    replaceCheckIcon() {
      if (this.$refs.highlightText) {
        this.$refs.highlightText.innerHTML = this.$refs.highlightText.innerHTML.replace(/<i class="icon icon-check"><\/i>/ig, this.$refs.checkIcon.innerHTML);
      }
    }
  },
};
</script>
